import {
  ActionType,
  EventType,
  PageName,
  SourceType
} from '@/types/track-events'

import { OnboardingService } from '@/services'

const getUA = () => {
  let device = 'Unknown'
  const ua = {
    'Generic Linux': /Linux/i,
    Android: /Android/i,
    BlackBerry: /BlackBerry/i,
    Bluebird: /EF500/i,
    'Chrome OS': /CrOS/i,
    Datalogic: /DL-AXIS/i,
    Honeywell: /CT50/i,
    iPad: /iPad/i,
    iPhone: /iPhone/i,
    iPod: /iPod/i,
    macOS: /Macintosh/i,
    Windows: /IEMobile|Windows/i,
    Zebra: /TC70|TC55/i
  }
  Object.keys(ua).map(v => navigator.userAgent.match(ua[v]) && (device = v))
  return device
}

const detectBrowser = () => {
  const userAgent = navigator.userAgent
  if (userAgent.indexOf('Edg') > -1) {
    return 'Microsoft Edge'
  } else if (userAgent.indexOf('Chrome') > -1) {
    return 'Chrome'
  } else if (userAgent.indexOf('Firefox') > -1) {
    return 'Firefox'
  } else if (userAgent.indexOf('Safari') > -1) {
    return 'Safari'
  } else if (userAgent.indexOf('Opera') > -1) {
    return 'Opera'
  } else if (
    userAgent.indexOf('Trident') > -1 ||
    userAgent.indexOf('MSIE') > -1
  ) {
    return 'Internet Explorer'
  }

  return 'Unknown'
}

export async function trackCustomEvent(data: {
  eventType: EventType
  actionType: ActionType
  pageName: PageName
  elementName: string
  store: any
  value?: string
}) {
  try {
    const device = getUA()
    const browser = detectBrowser()
    const body = {
      eventType: data.eventType,
      actionType: data.actionType,
      pageName: data.pageName,
      elementName: data.elementName,
      value: data.value,
      device,
      browser,
      companyId: data.store.state.iframe.company.id,
      userId: data.store.state.iframe.userId,
      country: data.store.state.iframe.company.country,
      plan: data.store.state.iframe.company.plan,
      source: data.store.state.business.affiliateSignup
        ? SourceType.AFFILIATE
        : SourceType.FUNNEL,
      version: 1
    }
    await OnboardingService.trackEvents(body)
  } catch (error) {
    console.log(error)
  }
}

export async function trackCustomFieldEvent(data: {
  pageName: PageName
  elementName: string
  value: string
  store: any
}) {
  try {
    const body = {
      pageName: data.pageName,
      elementName: data.elementName,
      value: data.value,
      eventType: EventType.FIELD_VISIT,
      actionType: ActionType.CHANGE,
      store: data.store
    }
    await trackCustomEvent(body)
  } catch (error) {
    console.log(error)
  }
}
